import React, { Component } from 'react';

import Item from './item'
import * as func from "../../../../../utils/functions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from "../../../../../store/modules/scholars";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";

class SAdminSide extends Component {
  constructor(props) {
    super(props);

    if (location.search.substring(1)) {
      this.props.dataActions.setScholars({'param': func.parseParams(location.search.substring(1))});
    }
    // 이해 안됨.
    setTimeout(() => {
      this.getList();
    }, 0);
  }

  getList() {
    let param = this.props.param;
    param.record_per_page = 20;

    func.getData("admin/scholars", param).then((response) => {
      this.props.dataActions.setScholars(response);
    });
  }

  handlePageClick = (page) => {
    const paged = page.selected + 1;

    let param = this.props.param;
    param.records_per_page = 10;
    param['current_page'] = paged;

    func.getData("scholars", param).then((response) => {
      this.props.dataActions.setScholars({"param": param});
      const url = objectToQueryString(param);
      pushUrl('검색', "admin.php?page=scholar&record_id=" + func.getParams("record_id") + '&' + url, this.props.param);
      this.props.dataActions.setScholars(response);
    });
  }

  render() {
    const {records} = this.props;

    return (
      <>
        <table className="table table-striped table-thin border-bottom">
          <colgroup>
            <col width="50px"/>
            <col width=""/>
            <col width="60px"/>
          </colgroup>
          <thead>
            <tr>
              <th scope="col">NO</th>
              <th scope="col">저널명</th>
              <th scope="col">상태</th>
            </tr>
          </thead>
          <tbody>
          {records.map((record, index) => {
            const no = this.props.totalRecords - ((this.props.param.current_page - 1) * this.props.param.record_per_page) - index;
            return (
              <Item key={record.scholar_id} record={record} no={no} />
            )
          })}
          </tbody>
        </table>
        {this.props.totalPage > 1 &&
        <div className="mt-4">
          <div>
            <div className="paging-wrap">
              <ReactPaginate
                forcePage={Number(this.props.param.current_page) - 1}
                pageCount={this.props.totalPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                previousLabel="<"
                nextLabel=">"
                // breakLabel=".."
                onPageChange={this.handlePageClick}
                containerClassName={'pagination'}
                activeClassName={'active'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item page-item-prev'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item page-item-next'}
                nextLinkClassName={'page-link'}
              />
            </div>
          </div>
        </div>
        }
      </>
    )
  }
}


export default connect(
  (state) => ({
    param: state.scholars.param ? state.scholars.param : {},
    records: state.scholars.records ? state.scholars.records : [],
    totalRecords: state.scholars.totalRecords ? state.scholars.totalRecords : 0,
    totalPage: state.scholars.totalPage ? state.scholars.totalPage : 0,
  }),
  (dispatch) => ({
    dataActions: bindActionCreators(Actions, dispatch),
  }),
)(SAdminSide)

SAdminSide.propTypes = {
};
